import React from "react";
import "./NavbarPublic.css";
import { Link } from "react-router-dom";
import { SiGitbook } from "react-icons/si";
import { PiBookOpenText } from "react-icons/pi";
import { PiBookOpenUser } from "react-icons/pi";
import { ReactComponent as AprendoleIcon } from "../../icons/AprendoleIcon5.svg";
import { MdMenuBook } from "react-icons/md";
import { BiBookReader } from "react-icons/bi";
import { PiBooks } from "react-icons/pi";
import { PiBooksLight } from "react-icons/pi";
import { BsBookshelf } from "react-icons/bs";
import { SiWikibooks } from "react-icons/si";
import { PiBookmarks } from "react-icons/pi";
import { PiBookOpenTextFill } from "react-icons/pi";
import { PiBookBookmark } from "react-icons/pi";
import { BiSolidBookmarkAlt } from "react-icons/bi";
import { SlPaperPlane } from "react-icons/sl";
import { LuScrollText } from "react-icons/lu";



import { LuLogIn } from "react-icons/lu";



const NavbarPublic = () => {
  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* Left: Logo Placeholder */}
        <div className="navbar-logo">
          <div className="navbar-banner-logo">
            <AprendoleIcon className="navbar-logo-icon logo-shiny" />
            <div className="navbar-logo-text">
              <h1 className="shiny-text-navbar">Aprendole
              </h1>
              {/* <p className="logo-subtag">Feito para brasileiros</p> */}
            </div>
          </div>
        </div>

        <nav className="navbar-links">
          <button
            className="nav-waitlist-link"
            data-tally-open="mYN7Dz"
            data-tally-layout="modal"
            data-tally-hide-title="1"
            onClick={() => {
              if (!window.Tally) {
                window.open("https://tally.so/r/mYN7Dz", "_blank", "noopener,noreferrer");
              }
            }}
          >
            Lista de espera
          </button>
        </nav>

        

        {/* Right: Links */}
        {/* <nav className="navbar-links">
          <Link to="/signin" className="btn navbar-login-btn">
            Entrar
          </Link>
          <Link to="/signup" className="btn navbar-start-btn">
          Comece grátis
          </Link>
        </nav> */}
      </div>
    </header>
  );
};

export default NavbarPublic;

